/* import __COLOCATED_TEMPLATE__ from './responsive-picture.hbs.js'; */
var _dec, _dec2, _dec3, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { assert } from '@ember/debug';
import { computed } from '@ember/object';
import Component from '@glimmer/component';
let ResponsivePicture = (_dec = computed('this.args.sources.S'), _dec2 = computed('this.args.sources.M'), _dec3 = computed('this.args.sources.L'), _class = class ResponsivePicture extends Component {
  get srcsetSmall() {
    return this.getSrcset('S');
  }
  get srcsetMedium() {
    return this.getSrcset('M');
  }
  get srcsetLarge() {
    return this.getSrcset('L');
  }
  getSrcset(breakpoint) {
    const breakpointSrc = this.args.sources[breakpoint];
    if (!breakpointSrc) {
      return '';
    }
    assert(`You must pass at least one image path with a \`1x\` key to \`sources.${breakpoint}\``, breakpointSrc['1x']);
    const srcset = [`${breakpointSrc['1x']} 1x`];
    if (breakpointSrc['2x']) {
      srcset.push(`${breakpointSrc['2x']} 2x`);
    }
    return srcset.join(', ');
  }
}, _applyDecoratedDescriptor(_class.prototype, "srcsetSmall", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "srcsetSmall"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "srcsetMedium", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "srcsetMedium"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "srcsetLarge", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "srcsetLarge"), _class.prototype), _class);
export { ResponsivePicture as default };